export enum PropertyOwnershipTypes {
    UNKNOWN = 0,
    OWNED = 1,
    RENT_TO_RENT = 2,
    MANAGED = 3
}

export const PropertyOwnershipTypesReverse = {
    "0": "Unknown / Unset",
    "1": "Owned",
    "2": "Rent to Rent / Master Lease",
    "3": "Managed",
}

// These need to match exactly the ENUM names in C#
export const PropertyOwnershipTypesReverseExact = {
    "0": "UNKNOWN",
    "1": "OWNED",
    "2": "RENT_TO_RENT",
    "3": "MANAGED",
}
